import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import classes from "./options_drop_down.module.css";
import { Box, Typography, Popover } from "@mui/material";

const OptionsDropDown = ({
  options,
  name,
  onChangeHandler,
  isDisabled,
  value,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    if (isDisabled) return; // Prevent opening if disabled
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box style={{ width: "100%" }}>
      <Box 
        onClick={handleOpen} 
        className={classes["selectTitleLanguage"]}
        role="combobox"
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={name}
        tabIndex={isDisabled ? -1 : 0}
        style={{
          cursor: isDisabled ? "not-allowed" : "pointer",
          pointerEvents: isDisabled ? "none" : "auto",
          opacity: isDisabled ? 0.5 : 1,
        }}>
        <Box className={classes["languageSelectBox"]} style={{ width: "100%" }}>
          <Typography
            className={classes["languageSelectText"]}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flexGrow: 1, // Allow text to take available space
              minWidth: 0, // Prevent text from pushing other elements
            }}
          >
            {
              (() => {
                // If options are objects with { name, value }, display the matching name.
                // Otherwise, display the raw value.
                const hasObjectOptions = Array.isArray(options) && options.length > 0 && typeof options[0] === 'object' && options[0] !== null && 'value' in options[0];
                if (hasObjectOptions) {
                  const match = options.find((opt) => opt && typeof opt === 'object' && 'value' in opt && opt.value === value);
                  return (match && match.name) || (value !== undefined && value !== null && `${value}`) || "None selected";
                }
                return (value !== undefined && value !== null && `${value}`) || "None selected";
              })()
            }
          </Typography>
          <Box style={{ display: "flex", flexShrink: 0 }}> {/* Prevent icon from shrinking */}
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
              className={anchorEl ? classes.svgRotate : ""}
            >
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
            </svg>
          </Box>
        </Box>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        role="listbox"
      >
        <div>
          {options.map((option, index) => (
            <MenuItem
              name={name}
              key={index}
              role="menuitem"
              onClick={() => {
                const selectedValue = option.name ? option.value : option;
                onChangeHandler({ target: { name: name, value: selectedValue } });
                handleClose();
              }}
              value={option.name ? option.value : option}
            >
              {option.name ? option.name : option}
            </MenuItem>
          ))}
        </div>
      </Popover>
    </Box>
  );
};

export default OptionsDropDown;
